import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase';

Vue.config.productionTip = true

let app = '';

// TODO: move out
const config = {
  apiKey: "AIzaSyCdZefsZ2axJNfn1fg43uZWNAVrTeObbIg",
  authDomain: "about-this-app.firebaseapp.com",
  projectId: "about-this-app",
  storageBucket: "about-this-app.appspot.com",
  messagingSenderId: "71656027739",
  appId: "1:71656027739:web:effa2609b4c9cd11aa717e"
};

firebase.initializeApp(config);

export const database = firebase.firestore()

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
